import { useState, useEffect } from 'react';

import noop from 'lodash-es/noop';

/**
 * The custom hook to use along with the saving status control like `<SaveBar>`.
 * It hides the save control after a timeout is reached.
 * @param isSaved - whether the form is saved
 * @param timeout - the timeout
 * @returns whether we should show the save button
 */
export function useSaveStatusHook(isSaved: boolean, timeout = 1000): boolean {
  const [shouldShowSaveButton, setShouldShowSaveButton] = useState(false);

  useEffect(() => {
    if (isSaved) {
      setShouldShowSaveButton(true);

      const timer = window.setTimeout(() => {
        setShouldShowSaveButton(false);
      }, timeout);

      return () => clearTimeout(timer);
    }

    return noop;
  }, [isSaved, timeout]);

  return shouldShowSaveButton;
}
